/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	AcademicUserProfileDTO,
	AcademicUserProfileDTOFromJSON,
	AcademicUserProfileDTOFromJSONTyped,
	AcademicUserProfileDTOToJSON,
} from "./AcademicUserProfileDTO";

/**
 *
 * @export
 * @interface AcademicUserProfilesResponseDTO
 */
export interface AcademicUserProfilesResponseDTO {
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserProfilesResponseDTO
	 */
	name?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserProfilesResponseDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {number}
	 * @memberof AcademicUserProfilesResponseDTO
	 */
	cursId?: number;
	/**
	 *
	 * @type {Array<AcademicUserProfileDTO>}
	 * @memberof AcademicUserProfilesResponseDTO
	 */
	profiles?: Array<AcademicUserProfileDTO> | null;
}

export function AcademicUserProfilesResponseDTOFromJSON(
	json: any
): AcademicUserProfilesResponseDTO {
	return AcademicUserProfilesResponseDTOFromJSONTyped(json, false);
}

export function AcademicUserProfilesResponseDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AcademicUserProfilesResponseDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		name: !exists(json, "name") ? undefined : json["name"],
		email: !exists(json, "email") ? undefined : json["email"],
		cursId: !exists(json, "cursId") ? undefined : json["cursId"],
		profiles: !exists(json, "profiles")
			? undefined
			: json["profiles"] === null
			? null
			: (json["profiles"] as Array<any>).map(AcademicUserProfileDTOFromJSON),
	};
}

export function AcademicUserProfilesResponseDTOToJSON(
	value?: AcademicUserProfilesResponseDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		name: value.name,
		email: value.email,
		cursId: value.cursId,
		profiles:
			value.profiles === undefined
				? undefined
				: value.profiles === null
				? null
				: (value.profiles as Array<any>).map(AcademicUserProfileDTOToJSON),
	};
}
